import * as React from 'react';
import { Checkbox as BaseCheckbox } from '@mc/react-core';
import classNames from 'classnames';
import { useTheme } from '../useTheme';

type Props = Omit<React.ComponentProps<typeof BaseCheckbox>, 'tagName'> & {};

export const Checkbox: React.FC<Props> = ({ className, ...other }) => {
  const theme = useTheme();
  let cls = classNames(`${theme.ns}-checkbox`, className, {});

  return <BaseCheckbox className={cls} {...other} />;
};
